"use client";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { definitions } from "@/services/metruyenvl";

function SaveReadingsChapter({ book, chapter }: { book: definitions["do.BookDO"]; chapter: definitions["do.ChapterContentRes"] }) {
    const dispatch = useDispatch();
    useEffect(() => {
        // dispatch(updateChapterIndex(detail));
    }, [book, chapter]);
    return <></>;
}

export default SaveReadingsChapter;
